import { useWebAlert } from '@/src/components/ui/elements/dialogs/Alert'
import type { UseAlert } from '@/src/components/ui/elements/dialogs/useAlert'
import { useMemo } from 'react'
import { useEvent } from 'tamagui'

export const useAlert: UseAlert = (...args) => {
  const { alert: webAlert } = useWebAlert(...args)
  const alert: ReturnType<UseAlert>['alert'] = useEvent(
    (title, message = '', buttons = [], options) =>
      webAlert({
        title,
        message,
        buttons: buttons.map((button) => ({
          title: button.text ?? '',
          style: button.style ?? 'default',
          action: () => button.onPress?.(),
        })),
        options,
      }),
  )

  return useMemo(() => ({ alert }), [alert])
}
